import { useSuspenseQueries } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { claimQueries } from '@repo/api/claim/claims';
import { questionnaireQueries } from '@repo/api/claim/questionnaire';
import useCurrency from '@repo/features/hooks/useCurrency';

import {
	LegacyLossSummary,
	MonthlyTier2LossSummary,
} from './-components/LossSummary';

export const Route = createFileRoute(
	'/_claims/claim/$claimId/_claim/calculations/loss',
)({
	component: function LossCalculationsPage() {
		const { claimId } = Route.useParams();

		const [{ data: claim }, { data: questionnaire }] = useSuspenseQueries({
			queries: [claimQueries.id(claimId), questionnaireQueries.id(claimId)],
		});

		const currency = useCurrency(claim.claimInsured.countryId);
		const isTierTwo = claim.isTier2Enabled && questionnaire.isTier2;
		const isMonthlyTier2Claim =
			isTierTwo && claim.estimatedPeriodofIndemnityDateType === 2;

		return isMonthlyTier2Claim ?
				<MonthlyTier2LossSummary claimId={claimId} currency={currency} />
			:	<LegacyLossSummary
					claimId={claimId}
					claim={claim}
					currency={currency}
					isTierTwo={isTierTwo}
				/>;
	},
});
